// 确保chat-toggle按钮被隐藏的JavaScript解决方案
(function() {
    'use strict';
    
    // 立即隐藏所有chat-toggle按钮
    function hideChatToggleButtons() {
        const buttons = document.querySelectorAll('.chat-toggle, button.chat-toggle');
        buttons.forEach(button => {
            button.style.display = 'none';
            button.style.visibility = 'hidden';
            button.style.opacity = '0';
            button.style.pointerEvents = 'none';
            button.style.position = 'absolute';
            button.style.left = '-9999px';
            button.style.width = '0';
            button.style.height = '0';
            button.style.overflow = 'hidden';
            button.style.clip = 'rect(0, 0, 0, 0)';
            
            // 添加hidden类
            button.classList.add('hidden');
        });
    }
    
    // 监听DOM变化，防止按钮重新出现
    function observeDOM() {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) { // Element node
                            if (node.classList && (node.classList.contains('chat-toggle') || 
                                node.querySelector && node.querySelector('.chat-toggle'))) {
                                hideChatToggleButtons();
                            }
                        }
                    });
                }
            });
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    
    // 页面加载时立即执行
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            hideChatToggleButtons();
            observeDOM();
        });
    } else {
        hideChatToggleButtons();
        observeDOM();
    }
    
    // 定期检查，确保按钮保持隐藏状态
    setInterval(hideChatToggleButtons, 1000);
})();